import React, { useEffect, useState } from "react";
import axios from "../utils/axios";
import { RemoteImg } from './RemoteMedia';

export default function FloatingContact({ phone: phoneProp = "+84901234567" }) {
  const [phone, setPhone] = useState(phoneProp);
  const [buttons, setButtons] = useState([]);

  useEffect(() => {
    let mounted = true;
    // fetch contact phone
    axios
      .get('/public/contact-info')
      .then((res) => {
        if (!mounted) return;
        const p = res.data && res.data.phone ? res.data.phone : phoneProp;
        setPhone(p);
      })
      .catch(() => {});

    // fetch floatbuttons data (img + link + title)
    axios
      .get('/admin/floatbuttons')
      .then((res) => {
        if (!mounted) return;
        if (Array.isArray(res.data)) setButtons(res.data || []);
      })
      .catch(() => {});

    return () => (mounted = false);
  }, [phoneProp]);

  const rawNumber = (phone || phoneProp).replace(/[\s+\-()]/g, "");
  const zaloLink = `https://zalo.me/${rawNumber.replace(/^0/, "84")}`;

  const hasImg0 = Boolean(buttons[0]?.img);
  const hasImg1 = Boolean(buttons[1]?.img);

  return (
    <div className="fixed left-6 bottom-6 z-50 flex flex-col gap-3 items-end">
      <a
        href={buttons[0]?.link || zaloLink}
        target={buttons[0]?.link ? '_self' : '_blank'}
        rel={buttons[0]?.link ? undefined : 'noopener noreferrer'}
        aria-label={buttons[0]?.title || 'Chat Zalo'}
        className={`flex items-center justify-center w-12 h-12 rounded-full ${hasImg0 ? 'bg-transparent' : 'bg-blue-600'} text-white shadow-lg hover:scale-105 transition overflow-hidden p-0`}
        title={buttons[0]?.title || 'Chat Zalo'}
      >
        {buttons[0]?.img ? (
          <RemoteImg src={buttons[0].img} alt={buttons[0]?.title || 'zalo'} className="w-full h-full object-cover" />
        ) : (
          <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M6 8h12v2L10 17H16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
      </a>

      <a
        href={buttons[1]?.link || `tel:${rawNumber}`}
        aria-label={buttons[1]?.title || 'Gọi ngay'}
        className={`flex items-center justify-center w-12 h-12 rounded-full ${hasImg1 ? 'bg-transparent' : 'bg-green-500'} text-white shadow-lg hover:scale-105 transition overflow-hidden p-0`}
        title={buttons[1]?.title || 'Gọi ngay'}
      >
        {buttons[1]?.img ? (
          <RemoteImg src={buttons[1].img} alt={buttons[1]?.title || 'call'} className="w-full h-full object-cover" />
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path d="M2.003 5.884l2-3A1 1 0 015 2h3a1 1 0 011 1v3a1 1 0 01-.293.707L7.414 8.414a12.042 12.042 0 005.172 5.172l1.707-1.293A1 1 0 0115 12h3a1 1 0 011 1v3a1 1 0 01-0.884.993l-3 .5A17 17 0 012 5.884z" />
          </svg>
        )}
      </a>
    </div>
  );
}
